import React from 'react';
import { EntitiesTitleLink } from '../../../../../../components/entities-card/EntitiesTitleLink';
import { EntitiesCardTitle } from '../../../../../../components/entities-card/EntitiesCardTitle';
import { LegalTermIcon } from '../../../../../../components/entities-card/icons/LegalTermIcon';

type Props = React.HTMLProps<HTMLAnchorElement>;

export const LegalTermCardTitle: React.FC<Props> = ({
  children,
  ...props
}: Props) => (
  <EntitiesTitleLink {...props}>
    <EntitiesCardTitle icons={LegalTermIcon}>{children}</EntitiesCardTitle>
  </EntitiesTitleLink>
);
